var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_1959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 68,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 68,
    height: 68,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_1959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5834 72.6667C46.2222 72.6667 44.2153 71.8403 42.5625 70.1875C40.9097 68.5347 40.0834 66.5278 40.0834 64.1667H45.75C45.75 64.9694 46.0215 65.6424 46.5646 66.1854C47.1077 66.7285 47.7806 67 48.5834 67C49.3861 67 50.059 66.7285 50.6021 66.1854C51.1452 65.6424 51.4167 64.9694 51.4167 64.1667C51.4167 63.3639 51.1452 62.691 50.6021 62.1479C50.059 61.6049 49.3861 61.3333 48.5834 61.3333H21.6667V55.6667H48.5834C50.9445 55.6667 52.9514 56.4931 54.6042 58.1458C56.257 59.7986 57.0834 61.8056 57.0834 64.1667C57.0834 66.5278 56.257 68.5347 54.6042 70.1875C52.9514 71.8403 50.9445 72.6667 48.5834 72.6667ZM21.6667 44.3333V38.6667H59.9167C61.1445 38.6667 62.1597 38.2653 62.9625 37.4625C63.7653 36.6597 64.1667 35.6444 64.1667 34.4167C64.1667 33.1889 63.7653 32.1736 62.9625 31.3708C62.1597 30.5681 61.1445 30.1667 59.9167 30.1667C58.6889 30.1667 57.6736 30.5681 56.8709 31.3708C56.0681 32.1736 55.6667 33.1889 55.6667 34.4167H50C50 31.6306 50.9563 29.2813 52.8688 27.3688C54.7813 25.4563 57.1306 24.5 59.9167 24.5C62.7028 24.5 65.0521 25.4563 66.9646 27.3688C68.8771 29.2813 69.8334 31.6306 69.8334 34.4167C69.8334 37.2028 68.8771 39.5521 66.9646 41.4646C65.0521 43.3771 62.7028 44.3333 59.9167 44.3333H21.6667ZM68.4167 67V61.3333C69.6445 61.3333 70.6597 60.9319 71.4625 60.1292C72.2653 59.3264 72.6667 58.3111 72.6667 57.0833C72.6667 55.8556 72.2653 54.8403 71.4625 54.0375C70.6597 53.2347 69.6445 52.8333 68.4167 52.8333H21.6667V47.1667H68.4167C71.2028 47.1667 73.5521 48.1229 75.4646 50.0354C77.3771 51.9479 78.3334 54.2972 78.3334 57.0833C78.3334 59.8694 77.3771 62.2187 75.4646 64.1312C73.5521 66.0437 71.2028 67 68.4167 67Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAir);
export default __webpack_public_path__ + "static/media/logo_air.584b646567f0815396ee9ebda7b9c4f4.svg";
export { ForwardRef as ReactComponent };